module.exports = __webpack_public_path__ + "static/media/docx.3ffcbe85.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/attachment-icons/docx.svg
// module id = 1673
// module chunks = 17